// @flow
import React, { PureComponent } from "react";
import cx from "classnames";
import { Tooltip } from "react-tippy";
import t from "common/i18n";
import SvgIcon from "root/components/SvgIcon";
import SVG_ICONS from "~/assets/icons/icons";
import "./ColorPicker.scss";

type Props = {
	options: Array<{ value: string, label: string, darkCheck?: boolean }>,
	onChange: Function,
	className?: string,
	value: ?string,
};

class ColorPicker extends PureComponent<Props> {
	handleClick = (option: { value: string }) => {
		const { value, onChange } = this.props;
		if (option.value === value) {
			onChange(null);
		} else {
			onChange(option.value);
		}
	};
	
	render = () => {
		const { options, className, value } = this.props;
		return (
			<ul className={cx("color-picker flex flex-wrap", className)}>
				{options.map((option) => (
					<li key={option.value}
						onClick={() => this.handleClick(option)}
						className="flex-shrink-0">
						<Tooltip
							key={option.label}
							title={t(option.label)}
							arrow
							animation="scale"
							delay={250}
							duration={200}
							hideDelay={0}
							size="small"
							className="tip title-center">
							<div
								className="inner bc-menu-icons br1"
								style={{
									background: option.value,
								}}>
								{value === option.value
									? <SvgIcon path={SVG_ICONS.CHECKED}
											   color={option.darkCheck ? "black" : "white"}/>
									: null}
							</div>
						</Tooltip>
					</li>
				))}
			</ul>
		);
	}
}

export default ColorPicker;
